import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const col1 = categories.slice(0, 4);
  const col2 = categories.slice(4, 8);
  const col3 = categories.slice(8, 12);
  const col4 = categories.slice(12, 14);

  return (
    <footer className="bg-background-100 pt-16 pb-8 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-12">
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4 pb-2 border-b border-background-300/60">
              Categories
            </h4>
            <ul className="space-y-2.5">
              {col1.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4 pb-2 border-b border-background-300/60">
              More Categories
            </h4>
            <ul className="space-y-2.5">
              {col2.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4 pb-2 border-b border-background-300/60">
              Discover
            </h4>
            <ul className="space-y-2.5">
              {col3.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4 pb-2 border-b border-background-300/60">
              Resources
            </h4>
            <ul className="space-y-2.5">
              {col4.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
              <li>
                <Link to="/oopbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Complete Guide
                </Link>
              </li>
              <li>
                <Link to="/safety-disclaimer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Safety & Disclaimer
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors cursor-pointer"
                >
                  Main Site →
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-background-300/60 gap-4">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="font-heading text-2xl font-bold text-foreground-950">OOPBuy</span>
              <span className="font-heading text-2xl font-light text-foreground-700">Spreadsheet</span>
            </div>
            <p className="text-xs text-foreground-500 mt-1">Curated shopping lists & product guides.</p>
          </div>
          <div className="flex flex-col items-end gap-2">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} OOPBuy Spreadsheet. All rights reserved.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-global-line"></i>
              </a>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-shopping-cart-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}